import { inject, Injectable } from '@angular/core';
import { Observable, switchMap } from 'rxjs';
import { Operation } from 'fast-json-patch';
import { SchnFunctionsDataService } from './schn-functions-data.service';
import {
    LaneCreate,
    LaneDataService,
    LaneRead,
} from '@pf/platform-loads/domain';

@Injectable()
export class RadiusLaneDataService extends LaneDataService {
    private schnFunctions = inject(SchnFunctionsDataService);

    override createObs$(body: LaneCreate): Observable<LaneRead> {
        return this.schnFunctions.laneCreate({
            originLocationId: body.originLocationId!,
            destinationLocationId: body.destinationLocationId!,
        }) as Observable<LaneRead>;
    }

    override deleteObs$(laneId: string): Observable<LaneRead> {
        return this.schnFunctions.laneDelete(laneId) as Observable<LaneRead>;
    }

    override undoDeleteObs$(laneId: string): Observable<LaneRead> {
        return super
            .undoDeleteObs$(laneId)
            .pipe(switchMap(lane => this.updateObs$(laneId, [], lane)));
    }

    override updateObs$(
        laneId: string,
        _: Operation[],
        modified: LaneCreate
    ): Observable<LaneRead> {
        return this.schnFunctions.laneUpdate({
            laneId,
            originLocationId: modified.originLocationId!,
            destinationLocationId: modified.destinationLocationId!,
        }) as Observable<LaneRead>;
    }
}
